export enum DocsVerificationLivenessEnum {
    UP = 'up',
    RIGHT = 'right',
    DOWN = 'down',
    LEFT = 'left',
    CENTER = 'center',
}
